// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagePreview_bodyBlock__rud5W {
  margin-top: 60px;
  margin-left: -40px;
  padding: 0 40px;
}

.pagePreview_title__sx5Jy {
  word-break: break-word;
}

.pagePreview_bottomPanel__vkZm5 {
  position: fixed;
  z-index: 1;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: flex-end;

  width: calc(100% - 260px);
  padding: 10px 20px;

  background-color: var(--gray-05);
  grid-gap: 10px;
}

@media (max-width: 1366px) {
  .pagePreview_bottomPanel__vkZm5 {
    width: 100%;
  }
}

.pagePreview_topPanel__T639q {
  transition: 0.5s;
}

.pagePreview_hide__R55NL {
  transform: translateY(-100%);
}

.pagePreview_show__1xBe- {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/pagePreview.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,SAAS;;EAET,aAAa;EACb,yBAAyB;;EAEzB,yBAAyB;EACzB,kBAAkB;;EAElB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".bodyBlock {\n  margin-top: 60px;\n  margin-left: -40px;\n  padding: 0 40px;\n}\n\n.title {\n  word-break: break-word;\n}\n\n.bottomPanel {\n  position: fixed;\n  z-index: 1;\n  right: 0;\n  bottom: 0;\n\n  display: flex;\n  justify-content: flex-end;\n\n  width: calc(100% - 260px);\n  padding: 10px 20px;\n\n  background-color: var(--gray-05);\n  grid-gap: 10px;\n}\n\n@media (max-width: 1366px) {\n  .bottomPanel {\n    width: 100%;\n  }\n}\n\n.topPanel {\n  transition: 0.5s;\n}\n\n.hide {\n  transform: translateY(-100%);\n}\n\n.show {\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyBlock": `pagePreview_bodyBlock__rud5W`,
	"title": `pagePreview_title__sx5Jy`,
	"bottomPanel": `pagePreview_bottomPanel__vkZm5`,
	"topPanel": `pagePreview_topPanel__T639q`,
	"hide": `pagePreview_hide__R55NL`,
	"show": `pagePreview_show__1xBe-`
};
export default ___CSS_LOADER_EXPORT___;
